import { usePrefs } from 'wsm-common-data';

/**
 * Determines whether the main gallery image should be constrained to a 16:9 viewing area.
 * Reads the `galleryAspectRatio` pref and returns true when its value is '16:9'.
 *
 * @returns {boolean} is16by9ViewingArea
 */
const use16by9ViewingArea = () => {
	const { galleryAspectRatio } = usePrefs();
	return galleryAspectRatio === '16:9';
};

export default use16by9ViewingArea;
